module.exports = __webpack_public_path__ + "img/step1-t.fc17fbba.png";